var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessCheckMark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 10C19.6875 15.3503 15.3503 19.6875 10 19.6875C4.64973 19.6875 0.3125 15.3503 0.3125 10C0.3125 4.64973 4.64973 0.3125 10 0.3125C15.3503 0.3125 19.6875 4.64973 19.6875 10ZM8.87945 15.1295L16.067 7.94195C16.311 7.69789 16.311 7.30215 16.067 7.05809L15.1831 6.17422C14.939 5.93012 14.5433 5.93012 14.2992 6.17422L8.4375 12.0359L5.70082 9.29918C5.45676 9.05512 5.06102 9.05512 4.81691 9.29918L3.93305 10.183C3.68898 10.4271 3.68898 10.8229 3.93305 11.0669L7.99555 15.1294C8.23965 15.3735 8.63535 15.3735 8.87945 15.1295Z",
    fill: "#388200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckMark);
export default __webpack_public_path__ + "static/media/success-check-mark.808c59a1960f6fe00236808f4501717e.svg";
export { ForwardRef as ReactComponent };